module.exports = __webpack_public_path__ + "img/logo.9ac3795c.png";